// extracted by mini-css-extract-plugin
export var dateLabel = "_2d-0";
export var dateLabelError = "_2d-1";
export var fullWidth = "_2d-2";
export var smaller = "_2d-3";